function BrandSignature({ brandLogo, compact = false, label }) {
  return (
    <div className={`brand-signature${compact ? ' compact' : ''}`}>
      <img alt="ATA Code House branding" src={brandLogo} />
      <span>{label}</span>
    </div>
  );
}

export default BrandSignature;
